import { HausanschlussPrivateCards,
        HausanschlussBusinessCards, 
        HausanschlussPopupContainer,
        HausanschlussBusinessPopupContainer } from "./HausanschlussComp";
import { ErzeugungsanlagenPrivateCards,
         ErzeugungsanlagenBusinessCards,
         ErzeugungsanlagenPopupContainer,
         ErzeugungsanlagenBusinessPopupContainer} from "./ErzeugungsanlageComp";
import { RechtUndTechnikCards, RechtUndTechnikPopupContainer } from "./RechtUndTechnikComp";
import { PrimaryButton } from "../assets/primaryButton/primaryButton";
import { SecondaryButton } from "../assets/secondaryButton/secondaryButton";
import ScrollContainer from 'react-indiana-drag-scroll'
import "./components.scss";
import { useEffect, useState } from "react";
import "./popupPosition.scss";
import "../assets/svg/animationSVG/animationErzeugungsanlagen.scss"

export default function SecondLayer (props: {
    onBackNavigation: Function,
    text: any;
    desktop: boolean;
    layer: string;
    count: number;
    formulareIsActive?: boolean;
    thirdButton?: boolean
  }) {
    const text: any = props.text;
    const [openPopup, setOpenPopup] = useState(false);
    const [cardComponent, setCardComponent] = useState(<HausanschlussPrivateCards text={text} />);
    const [popupComponent, setPopupComponent] = useState(<HausanschlussPopupContainer text={text} setPopupState={()=>{setOpenPopup(false)}} />);

    useEffect(() =>{
        if(props.layer === 'Hausanschluss') {
            setCardComponent(<HausanschlussPrivateCards text={text} />)
            setPopupComponent(<HausanschlussPopupContainer text={text} setPopupState={()=>{setOpenPopup(false)}} />)
        } 
        else if(props.layer === 'HausanschlussBusiness') {
            setCardComponent(<HausanschlussBusinessCards text={text} />)
            setPopupComponent(<HausanschlussBusinessPopupContainer text={text} setPopupState={()=>{setOpenPopup(false)}} />)
        } 
        else if (props.layer === 'Erzeugungsanlagen') {
            setCardComponent(<ErzeugungsanlagenPrivateCards text={text} />)
            setPopupComponent(<ErzeugungsanlagenPopupContainer text={text}  setPopupState={()=>{setOpenPopup(false)}} />)
        }
        else if (props.layer === 'ErzeugungsanlagenBusiness') {
            setCardComponent(<ErzeugungsanlagenBusinessCards text={text} />)
            setPopupComponent(<ErzeugungsanlagenBusinessPopupContainer text={text}  setPopupState={()=>{setOpenPopup(false)}} />)
        }
        else if (props.layer === 'RechtUndTechnik') {
            setCardComponent(<RechtUndTechnikCards text={text} />)
            setPopupComponent(<RechtUndTechnikPopupContainer setPopupState={()=>{setOpenPopup(false)}} />)
        }
        else {
            setCardComponent(<div></div>)
            setPopupComponent(<div></div>)
        }

    },[props.layer, text])
  
    const gnoMobileComponentContainer = <div className="gno-component-container">
        <ScrollContainer hideScrollbars={false} className="gno-horizontal-scroll">
            <div className={props.count > 2 ? "gno-mobile-layout": "gno-two-columns"}>
                {cardComponent}
            </div>
        </ScrollContainer>
        <ButtonSpacing 
          onBackNavigation={()=>{props.onBackNavigation()}} 
          setPopupState = {()=>setOpenPopup(true)}
          formulareIsActive = {props.formulareIsActive}
          thirdButton = {props.thirdButton}
        />
        {openPopup ? popupComponent : <div></div>}
    </div>
  
    const gnoComponentContainer = <div className="gno-component-container" data-testid="hausanschlussComp">
        <ScrollContainer hideScrollbars={false} className="gno-horizontal-scroll">
          <div className={props.count > 2 ? "gno-layout": "gno-two-columns"}>
            {cardComponent}
          </div>
        </ScrollContainer>
        <ButtonSpacing 
          onBackNavigation={()=>{props.onBackNavigation()}} 
          setPopupState = {()=>setOpenPopup(true)}
          formulareIsActive = {props.formulareIsActive}
          thirdButton = {props.thirdButton}
        />
        {openPopup ? popupComponent : <div></div>}
    </div>
  
    return props.desktop ? gnoComponentContainer : gnoMobileComponentContainer;
}
  
function ButtonSpacing(props:{
onBackNavigation: Function,
setPopupState: Function,
formulareIsActive?: boolean,
thirdButton?: boolean
}) {
return <div className="gno-button-spacing">
        {props.formulareIsActive ? <PrimaryButton
            text="Formulare &amp; mehr"
            function={() => {
            props.setPopupState();
            }}
            negative={false}
        />
        :
        <></>}
        
        {props.thirdButton ? <PrimaryButton
            text="Netzengpässe"
            function={() => {
            window.open("/unternehmen/erzeugungsanlagen/verguetung", '_self')
            }}
            negative={false}
        />
        :
        <></>}
        <SecondaryButton
            text="Zurück zur Übersicht"
            function={() => {
                props.onBackNavigation();
            }}
            negative={false}
        />
    </div>
}